import { render } from "./Step_12.vue?vue&type=template&id=82ef85ee"
import script from "./Step_12.vue?vue&type=script&lang=js"
export * from "./Step_12.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__